import styled from 'styled-components';

export const Container = styled.div<{ $margin?: string }>`
    display: flex;
    flex-direction: column;
    margin: ${(p) => p.$margin || '0px'};
`;

export const ButtonContainer = styled.div`
    margin: 42px 0px 0px 0px;
`;

export const StyledModalContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const StyledContentImage = styled.img`
    width: 230px;
    margin: 10px 0px 20px 0px;
`;

export const StyledButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const UserRegisteredButton = styled.button(
    (p) => `
    color: ${p.theme.colors.loopEmerald};
    font-size: ${p.theme.fontSizes.body};
    background-color: ${p.theme.colors.coverUpGreen};
    font-weight: 700;
    border-radius: 16px;
    min-width: 150px;
    width:100%;
    cursor: pointer;
    padding: 18px 0px;
    display: flex;
    justify-content: center;
    border:none;
    align-items: center;
    font-style: normal;
    font-weight: 500;
    @media (max-width: 768px) {
        margin-top: 15px;
        width: 70%;
    }
`
);
